import { apiClient } from './apiClient';

import type { ApiResponse } from '@/types/auth.types';
import type {
  DocumentPolicy,
  DocumentPolicyFormData,
  DocumentPolicyListData,
  PolicyHistoryEntry,
} from '@/types/documentPolicy.types';

export async function listPolicies(): Promise<DocumentPolicy[]> {
  const response = await apiClient.get<ApiResponse<DocumentPolicyListData>>('/document-policies');
  return response.data.items;
}

export async function createPolicy(data: DocumentPolicyFormData): Promise<DocumentPolicy> {
  const response = await apiClient.post<ApiResponse<DocumentPolicy>>('/document-policies', data);
  return response.data;
}

export async function updatePolicy(id: string, data: Partial<DocumentPolicyFormData>): Promise<DocumentPolicy> {
  const response = await apiClient.put<ApiResponse<DocumentPolicy>>(`/document-policies/${id}`, data);
  return response.data;
}

export async function getPolicyHistory(policyId: string): Promise<PolicyHistoryEntry[]> {
  const response = await apiClient.get<ApiResponse<{ items: PolicyHistoryEntry[] }>>(
    `/document-policies/${policyId}/history`,
  );
  return response.data.items;
}
